// import React, { useContext, useState, useEffect } from "react";
// import {
//     Box,
//     Card,
//     CardActions,
//     Container,
//     CssBaseline,
//     Stack,
//     Typography,
//     useTheme,
// } from "@mui/material";
// import EnergyReportingChart from "../../../../../../components/charts/energy_reporting/EnergyReportingChart";
// import AppModal from "../../../../../../components/AppModal";
// import { InverterContext } from "../../../../../../context/InverterContext";
// import MonthlyFilterStrip from "./MonthlyFilterStrip";

// function MonthlyCurve() {
//     const getCurrentMonth = () => {
//         const now = new Date();
//         const year = now.getFullYear();
//         const month = String(now.getMonth() + 1).padStart(2, "0");
//         return `${year}-${month}`;
//     };

//     const { spacing } = useTheme();
//     const { monthlyData,monthlyLoading,monthlyError,MonthlyApi } = useContext(InverterContext);

//     const [startDate, setStartDate] = useState(getCurrentMonth());
//     const [endDate, setEndDate] = useState(getCurrentMonth());
//     const [chartData, setChartData] = useState([]);
//     const [chartLabels, setChartLabels] = useState([]);
//     const [open, setOpen] = useState(false);

//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     const onRefreshData = () => {
//         if (startDate && endDate) {
//             const credentials = {
//                 LOGIN_ID: localStorage.getItem("LoginID") || "",
//                 PASS_KEY: localStorage.getItem("KEY") || "xyz",
//                 LCODE: localStorage.getItem("LCODE") || "",
//                 MT1: startDate,
//                 MT2: endDate,
//                 TYP: "A",
//                 WEB_KEY: "WEBXYZ321",
//                 FID: "216HT001",
//             };
//             MonthlyApi(credentials); 
//         } else {
//             alert("Please provide valid dates.");
//         }
//     };

//     // Utility function to get random color
//     const getRandomColor = () => {
//         const letters = "0123456789ABCDEF";
//         let color = "#";
//         for (let i = 0; i < 6; i++) {
//             color += letters[Math.floor(Math.random() * 16)];
//         }
//         return color;
//     };

//     // Process chart data when monthlyData updates
//     useEffect(() => {
//         if (monthlyData) {
//             const processChartData = () => {
//                 const labels = [];
//                 const datasets = {};

//                 monthlyData.forEach((singleData) => {
//                     let chartKeys = Object.keys(singleData).filter(key =>
//                         key.includes('MONTH Total [KWH]')
//                     );

//                     labels.push(singleData.MONTH);

//                     chartKeys.forEach((key) => {
//                         if (!datasets[key]) {
//                             datasets[key] = [];
//                         }
//                         datasets[key].push(singleData[key]);
//                     });
//                 });

//                 const datasetArr = Object.keys(datasets).map((key) => ({
//                     label: key.replace("MONTH Total [KWH]", ""),
//                     data: datasets[key],
//                     borderColor: getRandomColor(),
//                     backgroundColor: getRandomColor(),
//                     tension: 0.3,
//                     borderWidth: 1,
//                     pointRadius: 2,
//                     pointHoverRadius: 3,
//                 }));

//                 setChartLabels(labels);
//                 setChartData(datasetArr);

//                 // console.log("Processed Chart Labels:", labels);
//                 // console.log("Processed Datasets:", datasetArr);
//             };

//             processChartData();
//         }
//     }, [monthlyData]);

//     return (
//         <>
//             <CssBaseline />
//             <Box
//                 component={Stack}
//                 sx={{ bgcolor: "background.default", rowGap: spacing(1), py: spacing(1) }}
//             >
//                 <MonthlyFilterStrip
//                     title="Monthly Energy Curve"
//                     ValueOf1={startDate}
//                     ValueOf2={endDate}
//                     onChangeValueOf1={(e) => setStartDate(e.target.value)}
//                     onChangeValueOf2={(e) => setEndDate(e.target.value)}
//                     onFullScreen={handleOpen}
//                     onRefreshData={onRefreshData}
//                 />

//                 {monthlyLoading ? (
//                     <Typography variant="body2" textAlign="center" color="primary.main">
//                         Data Loading...
//                     </Typography>
//                 ) : monthlyError ? (
//                     <Typography variant="body2" textAlign="center" color="error.main">
//                         Error loading data: {monthlyError.message}
//                     </Typography>
//                 ) : chartData.length === 0 ? (
//                     <Typography variant="body2" textAlign="center" color="black">
//                         No data available.
//                     </Typography>
//                 ) : (
//                     <>
//                         <Card>
//                             <CardActions>
//                                 <Container maxWidth={false}>
//                                     <EnergyReportingChart data={chartData} labels={chartLabels} />
//                                 </Container>
//                             </CardActions>
//                         </Card>
//                         <AppModal open={open} handleClose={handleClose}>
//                             <Box>
//                                 <Typography variant="h5" textAlign="center">
//                                 Monthly Energy Curve
//                                 </Typography>
//                                 <Container maxWidth={false}>
//                                     <EnergyReportingChart data={chartData} labels={chartLabels} />
//                                 </Container>
//                             </Box>
//                         </AppModal>
//                     </>
//                 )}
//             </Box>
//         </>
//     );
// }

// export default MonthlyCurve;


import React, { useContext, useState, useEffect, useRef } from "react";
import {
    Box,
    Card,
    CardActions,
    Container,
    CssBaseline,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import EnergyReportingChart from "../../../../../../components/charts/energy_reporting/EnergyReportingChart";
import AppModal from "../../../../../../components/AppModal";
import { InverterContext } from "../../../../../../context/InverterContext";
import MonthlyFilterStrip from "./MonthlyFilterStrip";

// function MonthlyCurve() {
//     const getCurrentMonth = () => {
//         const now = new Date();
//         const year = now.getFullYear();
//         const month = String(now.getMonth() + 1).padStart(2, "0");
//         return `${year}-${month}`;
//     };

//     const { spacing } = useTheme();
//     const { monthlyData, monthlyLoading, monthlyError, MonthlyApi } = useContext(InverterContext);

//     const [startDate, setStartDate] = useState(getCurrentMonth());
//     const [endDate, setEndDate] = useState(getCurrentMonth());
//     const [chartData, setChartData] = useState([]);
//     const [chartLabels, setChartLabels] = useState([]);
//     const [open, setOpen] = useState(false);

//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     const onRefreshData = () => {
//         if (startDate && endDate) {
//             const credentials = {
//                 LOGIN_ID: localStorage.getItem("LoginID") || "",
//                 PASS_KEY: localStorage.getItem("KEY") || "xyz",
//                 LCODE: localStorage.getItem("LCODE") || "",
//                 MT1: startDate,
//                 MT2: endDate,
//                 TYP: "A",
//                 WEB_KEY: "WEBXYZ321",
//                 FID: "216HT001",
//             };
//             MonthlyApi(credentials);
//         } else {
//             alert("Please provide valid dates.");
//         }
//     };

//     // Utility function to get random color
//     const getRandomColor = () => {
//         const letters = "0123456789ABCDEF";
//         let color = "#";
//         for (let i = 0; i < 6; i++) {
//             color += letters[Math.floor(Math.random() * 16)];
//         }
//         return color;
//     };

//     // Process chart data when monthlyData updates
//     // Process chart data when monthlyData updates
//     useEffect(() => {
//         if (monthlyData && Array.isArray(monthlyData)) {
//             const processChartData = () => {
//                 const labels = [];
//                 const datasets = {};

//                 monthlyData.forEach((singleData) => {
//                     // ✅ Only pick keys like "INV-01 MONTH Total[KWH]"
//                     let chartKeys = Object.keys(singleData).filter(
//                         key => key.startsWith("INV-") && key.includes("MONTH Total[KWH]")
//                     );

//                     labels.push(singleData.MONTH);

//                     chartKeys.forEach((key) => {
//                         if (!datasets[key]) {
//                             datasets[key] = [];
//                         }
//                         datasets[key].push(singleData[key]);
//                     });
//                 });

//                 // ✅ Create datasets for chart.js
//                 const datasetArr = Object.keys(datasets).map((key) => ({
//                     label: key.replace(" MONTH Total[KWH]", ""), // Clean label
//                     data: datasets[key],
//                     borderColor: getRandomColor(),
//                     backgroundColor: getRandomColor(),
//                     tension: 0.3,
//                     borderWidth: 1,
//                     pointRadius: 2,
//                     pointHoverRadius: 3,
//                 }));

//                 setChartLabels(labels);
//                 setChartData(datasetArr);

//                 // console.log("Processed Chart Labels:", labels);
//                 // console.log("Processed Datasets:", datasetArr);
//             };

//             processChartData();
//         }
//     }, [monthlyData]);

//     return (
//         <>
//             <CssBaseline />
//             <Box 
//                 component={Stack}
//                 sx={{ bgcolor: "background.default", rowGap: spacing(1), py: spacing(1) }}
//             >
//                 <MonthlyFilterStrip
//                     title="Monthly Energy Curve"
//                     ValueOf1={startDate}
//                     ValueOf2={endDate}
//                     onChangeValueOf1={(e) => setStartDate(e.target.value)}
//                     onChangeValueOf2={(e) => setEndDate(e.target.value)}
//                     onFullScreen={handleOpen}
//                     onRefreshData={onRefreshData}
//                 />

//                 {monthlyLoading ? (
//                     <Typography variant="body2" textAlign="center" color="primary.main">
//                         Data Loading...
//                     </Typography>
//                 ) : monthlyError ? (
//                     <Typography variant="body2" textAlign="center" color="error.main">
//                         Error loading data: {monthlyError.message}
//                     </Typography>
//                 ) : chartData.length === 0 ? (
//                     <Typography variant="body2" textAlign="center" color="black">
//                         No data available.
//                     </Typography>
//                 ) : (
//                     <>
//                         <Card>
//                             <CardActions>
//                                 <Container maxWidth={false}>
//                                     <EnergyReportingChart data={chartData} labels={chartLabels} />
//                                 </Container>
//                             </CardActions>
//                         </Card>
//                         <AppModal open={open} handleClose={handleClose}>
//                             <Box>
//                                 <Typography variant="h5" textAlign="center">
//                                     Monthly Energy Curve
//                                 </Typography>
//                                 <Container maxWidth={false}>
//                                     <EnergyReportingChart data={chartData} labels={chartLabels} />
//                                 </Container>
//                             </Box>
//                         </AppModal>
//                     </>
//                 )}
//             </Box>
//         </>
//     );
// }

// export default MonthlyCurve;

function MonthlyCurve() {
    const chartRef = useRef();
    const getCurrentMonth = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    };

    const { spacing } = useTheme();
    const { monthlyData, monthlyLoading, monthlyError, MonthlyApi } = useContext(InverterContext);

    const [startDate, setStartDate] = useState(getCurrentMonth());
    const [endDate, setEndDate] = useState(getCurrentMonth());
    const [chartData, setChartData] = useState([]);
    const [chartLabels, setChartLabels] = useState([]);
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const onRefreshData = () => {
        if (startDate && endDate) {
            const credentials = {
                LOGIN_ID: localStorage.getItem("LoginID") || "",
                PASS_KEY: localStorage.getItem("KEY") || "xyz",
                LCODE: localStorage.getItem("LCODE") || "",
                MT1: startDate,
                MT2: endDate,
                TYP: "A",
                WEB_KEY: "WEBXYZ321",
                FID: "216HT001",
            };
            MonthlyApi(credentials);
        } else {
            alert("Please provide valid dates.");
        }
    };

    // Utility function to get random color
    const getRandomColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    // Process chart data when monthlyData updates
    // Process chart data when monthlyData updates
    useEffect(() => {
        if (monthlyData && Array.isArray(monthlyData)) {
            const processChartData = () => {
                const labels = [];
                const datasets = {};

                monthlyData.forEach((singleData) => {
                    // ✅ Only pick keys like "INV-01 MONTH Total[KWH]"
                    let chartKeys = Object.keys(singleData).filter(
                        key => key.startsWith("INV-") && key.includes("MONTH Total[KWH]")
                    );

                    labels.push(singleData.MONTH);

                    chartKeys.forEach((key) => {
                        if (!datasets[key]) {
                            datasets[key] = [];
                        }
                        datasets[key].push(singleData[key]);
                    });
                });

                // ✅ Create datasets for chart.js
                const datasetArr = Object.keys(datasets).map((key) => ({
                    label: key.replace(" MONTH Total[KWH]", ""), // Clean label
                    data: datasets[key],
                    borderColor: getRandomColor(),
                    backgroundColor: getRandomColor(),
                    tension: 0.3,
                    borderWidth: 1,
                    pointRadius: 2,
                    pointHoverRadius: 3,
                }));

                setChartLabels(labels);
                setChartData(datasetArr);

                // console.log("Processed Chart Labels:", labels);
                // console.log("Processed Datasets:", datasetArr);
            };

            processChartData();
        }
    }, [monthlyData]);

    return (
        <>
            <CssBaseline />
            <Box 
                component={Stack}
                sx={{ bgcolor: "background.default", rowGap: spacing(1), py: spacing(1) }}
            >
                <MonthlyFilterStrip
                    title="Monthly Energy Curve"
                    ValueOf1={startDate}
                    ValueOf2={endDate}
                    onChangeValueOf1={(e) => setStartDate(e.target.value)}
                    onChangeValueOf2={(e) => setEndDate(e.target.value)}
                    onFullScreen={handleOpen}
                    onRefreshData={onRefreshData}
                    chartRef={chartRef}
                />

                {monthlyLoading ? (
                    <Typography variant="body2" textAlign="center" color="primary.main">
                        Data Loading...
                    </Typography>
                ) : monthlyError ? (
                    <Typography variant="body2" textAlign="center" color="error.main">
                        Error loading data: {monthlyError.message}
                    </Typography>
                ) : chartData.length === 0 ? (
                    <Typography variant="body2" textAlign="center" color="black">
                        No data available.
                    </Typography>
                ) : (
                    <>
                        <Card ref={chartRef}>
                            <CardActions>
                                <Container maxWidth={false}>
                                    <EnergyReportingChart data={chartData} labels={chartLabels} />
                                </Container>
                            </CardActions>
                        </Card>
                        <AppModal open={open} handleClose={handleClose}>
                            <Box>
                                <Typography variant="h5" textAlign="center">
                                    Monthly Energy Curve
                                </Typography>
                                <Container maxWidth={false}>
                                    <EnergyReportingChart data={chartData} labels={chartLabels} />
                                </Container>
                            </Box>
                        </AppModal>
                    </>
                )}
            </Box>
        </>
    );
}

export default MonthlyCurve;